var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "#8D89A3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9249 18.6568C34.9249 17.1658 33.7038 15.9703 32.2113 15.9703H23.6363L24.9388 9.83164C24.9659 9.69732 24.9795 9.54956 24.9795 9.40181C24.9795 8.85108 24.7488 8.34064 24.3825 7.97797L22.9443 6.56756L14.0165 15.4061C13.5144 15.9031 13.2159 16.5747 13.2159 17.3135V30.746C13.2159 31.4585 13.5018 32.1418 14.0107 32.6456C14.5197 33.1494 15.2099 33.4324 15.9296 33.4324H28.1409C29.267 33.4324 30.2304 32.7608 30.6374 31.7937L34.735 22.3238C34.8571 22.0149 34.9249 21.6925 34.9249 21.3432V18.6568ZM5.07507 33.4324H10.5023V17.3135H5.07507V33.4324Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.4062f958ead9a88d417190ce8fe1af8c.svg";
export { ForwardRef as ReactComponent };